import React, { useState, useEffect } from 'react'
import {
  List, ListItem, ListItemIcon,
  ListItemText, ListItemSecondaryAction,
  IconButton, Card
} from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import { makeStyles } from '@material-ui/styles'
import DateRangeIcon from '@material-ui/icons/DateRange'
import { callGetApiWithAuth } from 'utils/api'
import clsx from 'clsx'

export default function MonthListFilter({ handleSearch, searchParam }) {
  const classes = useStyles()
  const [months, setMonths] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    loadMonths()    
  }, [])
  const loadMonths = () => {
    setIsLoading(true)
    callGetApiWithAuth('news/months', onGetMonths, ()=>setIsLoading(false))
  }
  const onGetMonths = (data) => {
    setIsLoading(false)
    setMonths(data.data)
  }

  return (
    <>
      <Card className={classes.monthListCardView}>
        <List component='nav' className={classes.columnlistSection}>
        {isLoading? [...Array(6).keys()].map(index => 
          <ListItem
            key={index}
            button
          >
            <ListItemIcon className={classes.listIcon}>
              <Skeleton variant={'rect'} width={24} height={24} />
            </ListItemIcon>
            <ListItemText
              primary={<Skeleton />}
              classes={{
                primary: classes.listText,
              }}
            />
            <ListItemSecondaryAction>
              <Skeleton variant={'circle'} width={12} height={14} />
            </ListItemSecondaryAction>
          </ListItem>
        ) : 
        months && months.length > 0 && 
          months.map((month, index) => (
          <ListItem
            key={month.key}
            value={month.value}
            button
            onClick={() => handleSearch(month.value)}
            className={classes.dateSection}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <DateRangeIcon color={searchParam && searchParam.month && searchParam.month==month.value?'primary':'textPrmary'} />
            </ListItemIcon>
            <ListItemText
              primary={month.label}
              className={classes.listItemText}
              className={clsx(classes.listText, 
                searchParam && searchParam.month && searchParam.month==month.value && classes.listActiveText
              )}
            />
            <ListItemIcon className={classes.listItemIcon}>
              <IconButton edge='end' className={classes.newsCount} style={{backgroundColor: searchParam && searchParam.month && searchParam.month==month.value?'#05C1FF':'#ADB0C2'}}>
                {month.count}
              </IconButton>
            </ListItemIcon>
          </ListItem>
        ))}
        </List>
      </Card>
    </>
  )
}

const useStyles = makeStyles((theme) => ({
  monthListCardView: {
    height: '100%',
    boxShadow: '0px 2px 10px #e5e9f2',
  },
  listIcon: {
    minWidth: 40,
  },
  columnlistSection: {
    display: 'flex',
    flexDirection: 'column',
    '@media (max-width: 959px)': {
      flexDirection: 'row',
      overflowX: "auto",
    },
  },
  rowlistSection: {
    display: 'flex',
    flexDirection: 'row',
    overflowX: 'auto',
    '@media (min-width: 660px)': {
      display: 'none',
    },
  },
  dateSection: {
    '@media (min-width: 960px) and (max-width: 1044px)': {
      paddingLeft: 0,
      paddingRight: 0,
    },
    '@media (min-width: 660px) and (max-width: 960px)': {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  listText: {
    fontSize: 14,
    fontWeight: 500,
    minWidth: 80,
  },
  listItemText: {
    minWidth: 80,
  },
  listActiveText: {
    color: theme.palette.primary.primaryColor,
  },
  newsCount: {
    width: 24,
    height: 24,
    color: 'white',
    borderRadius: '50%',
    fontSize: 14,
    backgroundColor: theme.palette.primary.primaryColor
  },
  listItemIcon: {
    justifyContent: 'center',
    color: theme.palette.primary.main,
    '& .MuiSvgIcon-colorPrimary': {
      color: theme.palette.primary.primaryColor,
    },
  },
}))